import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { EngineProvider } from "./app/EngineProvider";
import "./styles/global.css";

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("#root not found");
}

/**
 * EngineProvider sits OUTSIDE StrictMode on purpose.
 *
 * StrictMode double-invokes effects for its subtree; keeping the engine owner
 * above it means its setup/cleanup runs once, so a simulated cleanup can never
 * dispose a live AudioEngine — and no timer heuristic is needed to tell the two
 * apart. The UI still gets StrictMode's checks.
 * See docs/implementation-plan.md 6.2.
 */
createRoot(rootElement).render(
  <EngineProvider>
    <StrictMode>
      <App />
    </StrictMode>
  </EngineProvider>,
);
